import { Designation, Total } from "../types"

export function designationTotalCents(designations: Designation[]): Total {
  const totalCents = designations.reduce((totalCents, designation) => {
    const amountInCents = Math.round(parseFloat(designation.amount) * 100) || 0
    return totalCents + amountInCents
  }, 0)

  return totalCents
}

export function designationTotal(designations: Designation[]): Total {
  return designationTotalCents(designations) / 100
}
